import React from "react";
import "./FeeList.css"; // Make sure to create this CSS file

const FeeList = () => {
  return (
    <div>
      <h3 className="title-Feelist p-5">Clinical Dermatology</h3>
      <div
        className=" about-summary-inline"
        style={{
          padding: "5px 0px 0px",
          marginBottom: "20px",
          textAlign: "justify",
          fontSize: "19px",
        }}
      >
        <p>
          The fees listed only cover Dr Ahmed’s fees for consultation and
          procedures. Please be aware there are additional fees for
          investigations, for expert analysis of skin samples by a Consultant
          Pathologist, and for costs of theatre equipment, which will be billed
          separately.
        </p>
      </div>
      <div className="container-Feelist">
        <div className="section">
          <h2 className="section-title">New Clinical Consultation</h2>
          <p className="price-Feelist">£250</p>
          <p className="description">
            Our clinical dermatology consultations typically take 20-25 minutes
            (for new cases) to complete and involve a thorough history-taking, a
            dermatoscopic assisted full skin examination, and a professional
            opinion on management. As part of the consultation, we provide a
            professional summary for your reference.
          </p>
          <p className="note">
            This type of consultation is recommended for patients who are able
            to attend in person and require a comprehensive dermatoscopic full
            skin examination.
          </p>
        </div>

        <div className="section">
          <h2 className="section-title">Follow–up Consultation</h2>
          <p className="price-Feelist">£150</p>
          <p className="description">
            Clinical dermatology follow-up consultations usually last between
            15-20 minutes. These consultations are designed to assess your
            response to treatment, monitor any medication tolerability issues,
            identify potential side effects, review investigative results,
            adjust medication dosage, and confirm your ongoing management plan.
          </p>
        </div>

        <div className="section">
          <h2 className="section-title">Bedside dermatological treatments</h2>
          <p className="note mt-3">
            Treatment options under this category can be provided on the same
            day during consultation
          </p>

          <div className="treatment">
            <h3 className="treatment-title">Cryotherapy (1-3 lesions)</h3>
            <p className="price-Feelist">£100</p>
            <p className="description">
              Treatment for skin lesions with medical grade cryogen (liquid
              nitrogen), carried by a Consultant Dermatologist with special
              interest and research experience in cryotherapy.
            </p>
          </div>

          <div className="treatment">
            <h3 className="treatment-title">Cryotherapy (4-10 lesions)</h3>
            <p className="price-Feelist">£200</p>
            <p className="description">
              Treatment for skin lesions with medical grade cryogen (liquid
              nitrogen), carried by a Consultant Dermatologist with special
              interest and research experience in cryotherapy.
            </p>
          </div>

          <div className="treatment">
            <h3 className="treatment-title">Cortisone injection</h3>
            <p className="price-Feelist">£100 - £200</p>
            <p className="description">
              Cortisone injection is a medical treatment commonly used for acne
              cysts, keloid scars, alopecia areata.
            </p>
          </div>
        </div>

        <div className="section">
          <h2 className="section-title">
            Theatre based dermatology tests & treatment
          </h2>

          <div className="treatment">
            <h3 className="treatment-title">Diagnostic skin biopsy</h3>
            <p className="price-Feelist">£300</p>
            <p className="description">
              The aim of diagnostic biopsy is to harvest a small amount of skin
              tissue for diagnostic purposes. Assessment on optimal site for
              tissue harvesting is carried out by a Consultant Dermatologist
              with experience & interest in clinical & pathological correlation.
              The procedure is generally very well tolerated, resulting in a
              smallest possible scar with short recovery time.
            </p>
          </div>

          <div className="treatment">
            <h3 className="treatment-title">Diagnostic scalp skin biopsy</h3>
            <p className="price-Feelist">£300</p>
            <p className="description">
              This is a highly specialised dermatological procedure to assess
              the cause of alopecia (hair loss). It is carried out with
              standardised dermatological instrument and nationally agreed
              approach, under local anaesthesia and aseptic technique. Two
              samples are required from the affected site on the scalp. The
              procedure is generally very well tolerated, with a small resulting
              scar and short recovery time.
            </p>
          </div>

          <div className="treatment">
            <h3 className="treatment-title">
              Excisional biopsy of benign skin lesion
            </h3>
            <p className="price-Feelist">£300+</p>
            <p className="description">
              An excisional biopsy aims to remove a skin lesion completely,
              under local anaesthetic and aseptic technique. The appearance of
              the resulting scar is dependence on the method employed on wound
              closure. Discuss with your dermatologist.
            </p>
          </div>

          <div className="treatment">
            <h3 className="treatment-title">
              Excisional biopsy for malignant/cancerous lesion with direct wound
              closure
            </h3>
            <p className="price-Feelist">£500+</p>
            <p className="description">
              An excisional biopsy of skin cancer aims to remove the confirmed
              skin cancer in one setting completely, under local anaesthetic and
              aseptic technique. The approach varies depending on size, depth,
              specifics of cancer types and presentation.
            </p>
          </div>

          <div className="treatment">
            <h3 className="treatment-title">
              Excisional biopsy for malignant/cancerous lesion with complex
              repair
            </h3>
            <p className="price-Feelist">£POA</p>
            <p className="description">
              Excision of large skin cancer that requires flap & graft closure.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeList;
